import React, { useEffect, useState } from "react";
import {
	Card,
	CardBody,
	CardHeader,
} from "../../../../_metronic/_partials/controls";
import Table, { dateFormatter } from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import { getScenes } from "../../../../api/scene";
import { getGames } from "../../../../api/game";
import { alertError } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import EqualizerIcon from "@material-ui/icons/Equalizer";

function getData(scenes) {
	let data = [];
	for (let i = 0; i < scenes.length; ++i) {
		const elem = {};
		elem.name = scenes[i].fullName;
		elem.createdAt = scenes[i].createdAt;
		elem.id = scenes[i]._id;
		data = data.concat(elem);
	}
	return data;
}

export default function ScenesPage() {
	const [games, setGames] = useState([]);
	const [selectedGameId, setSelectedGameId] = useState("");
	const [data, setData] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();

	useEffect(() => {
		getGames()
			.then((res) => {
				if (res.status === 200 && res.data && res.data.length) {
					setGames(res.data);
					const defaultGame = res.data.find((g) => g.default) || res.data[0];
					if (!selectedGameId) setSelectedGameId(defaultGame._id);
				}
			})
			.catch(() => {});
	}, []);

	useEffect(() => {
		getScenes()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data || []));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get scenarios.",
				});
			});
	}, [refresh]);

	function buttonFormatter(cell) {
		return (
			<>
				<Tooltip title="Quiz">
					<Button onClick={() => history.push("/scenario/" + cell)}>
						<EqualizerIcon style={{ marginRight: "10px" }} />
						{"Answers"}
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "name", text: "Full name", sort: true },
		{
			dataField: "createdAt",
			text: "Created at",
			align: "center",
			headerAlign: "center",
			formatter: dateFormatter,
			sort: true,
		},
		{
			dataField: "id",
			text: "Statistics",
			align: "center",
			headerAlign: "center",
			formatter: buttonFormatter,
		},
	];

	return (
		<>
			<Card>
				<CardHeader title="Scenarios list"></CardHeader>
				<CardBody>
					<div className="form-group mb-4">
						<label htmlFor="scenes-game-select" className="font-weight-bold">
							Select a game
						</label>
						<select
							id="scenes-game-select"
							className="form-control"
							style={{ maxWidth: 320 }}
							value={selectedGameId}
							onChange={(e) => setSelectedGameId(e.target.value)}
						>
							<option value="">All games</option>
							{games.map((game) => (
								<option key={game._id} value={game._id}>
									{game.fullName}
								</option>
							))}
						</select>
						<small className="form-text text-muted">
							The same scenarios appear for all games. The selected game is the context for editing and saving info in each scenario.
						</small>
					</div>
					<Table data={data} columns={columns} />
				</CardBody>
			</Card>
		</>
	);
}
